import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import { Link, Stack, Button, Tooltip, IconButton, Typography } from '@mui/material';
//
import Iconify from './Iconify';

// ----------------------------------------------------------------------
const social = {
  facebook: 'https://www.facebook.com/APIZFTogo?mibextid=LQQJ4d',
  intagram: 'https://instagram.com/apizf_togo?igshid=MmJiY2I4NDBkZg==',
  linkedin: 'https://www.linkedin.com/company/agence-de-promotion-des-investissements-et-de-la-zone-franche-togo/',
  twitter: 'https://twitter.com/apizftogo?s=11',
};

SocialsButton.propTypes = {
  direction: PropTypes.oneOf(['row', 'column']),
  initialColor: PropTypes.bool,
  links: PropTypes.objectOf(PropTypes.string),
  simple: PropTypes.bool,
  sx: PropTypes.object,
};

// Affiche les liens réseaux sociaux en icônes seules ou avec libellés visibles
export default function SocialsButton({
  direction = 'row',
  initialColor = false,
  simple = true,
  links = social,
  sx,
  ...other
}) {
  const SOCIALS = [
    {
      name: 'Facebook',
      icon: 'eva:facebook-fill',
      socialColor: '#1877F2',
      path: links.facebook || '#facebook-link',
    },
    {
      name: 'LinkedIn',
      icon: 'eva:linkedin-fill',
      socialColor: '#007EBB',
      path: links.linkedin || '#linkedin-link',
    },
    {
      name: 'X (Twitter)',
      icon: 'eva:twitter-fill',
      socialColor: '#00AAEC',
      path: links.twitter || '#twitter-link',
    },
    {
      name: 'Instagram',
      icon: 'ph:instagram-logo',
      socialColor: '#C13584',
      path: links.intagram || '#intagram-link',
    },
  ];

  return (
    <Stack
      direction={direction}
      flexWrap="wrap"
      alignItems={direction === 'column' ? 'flex-start' : 'center'}
      spacing={direction === 'column' ? 1 : 2}
    >
      <Typography color="common.white" component="p" variant="overline">Suivez l'API-ZF sur</Typography>
      {SOCIALS.map((socialItem) => {
        const { name, icon, path, socialColor } = socialItem;
        const accessibleLabel = `Suivez l'API-zF sur ${name}`;

        return simple ? (
          <Link key={name} href={path} target="_blank" aria-label={accessibleLabel}>
            <Tooltip title={name} placement="top">
              <IconButton
                color="inherit"
                aria-label={accessibleLabel}
                sx={{
                  ...(initialColor && {
                    color: socialColor,
                    bgcolor: '#FFF',
                    '&:hover': {
                      bgcolor: alpha('#FFF', 0.8),
                    },
                  }),
                  ...sx,
                }}
                {...other}
              >
                <Iconify icon={icon} sx={{ width: 20, height: 20 }} />
              </IconButton>
            </Tooltip>
          </Link>
        ) : (
          <Button
            key={name}
            href={path}
            target="_blank"
            color="inherit"
            variant="outlined"
            size="small"
            aria-label={accessibleLabel}
            startIcon={<Iconify icon={icon} />}
            sx={{
              m: 0.5,
              width: 150,
              minWidth: 150,
              flexShrink: 0,
              justifyContent: 'flex-start',
              ...(initialColor && {
                color: socialColor,
                borderColor: socialColor,
                bgcolor: '#FFF',
                '&:hover': {
                  borderColor: socialColor,
                  bgcolor: alpha('#FFF', 0.85),
                },
              }),
              ...sx,
            }}
            {...other}
          >
            {name}
          </Button>
        );
      })}
    </Stack>
  );
}
